module.exports = __webpack_public_path__ + "img/SeSA Coin Laundry.83c371ad.svg";